<template>
  <div id="register">
    <Loading :loading="isLoading"></Loading>
    <top-nav></top-nav>
    <br />
    <br />
    <b-row>
      <b-col xl="4" offset-xl="4" lg="6" offset-lg="3" md="8" offset-md="2" sm="12" cols="8" offset="2" class="mb-3">
        <b-form-group id="field-title" label="คำนำหน้าชื่อ" label-for="title" :state="stateTitle">
          <b-form-input id="title" v-model="title" :state="stateTitle"></b-form-input>
        </b-form-group>
        <b-row>
          <b-col>
            <b-form-group id="field-firstname" label="ชื่อ" label-for="firstname" :state="stateFirstname">
              <b-form-input id="firstname" placeholder="ชื่อ" v-model="firstname" :state="stateFirstname"
                trim></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="field-lastname" label="นามสกุล" label-for="lastname" :state="stateLastName">
              <b-form-input id="lastname" placeholder="นามสกุล" v-model="lastname" :state="stateLastName"
                trim></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-form-group id="field-position" label="บัตรประชาชน" label-for="citizen_id" :state="stateCitizenId">
          <b-form-input id="position" v-model="citizen_id" :state="stateCitizenId"></b-form-input>
        </b-form-group>

        <b-form-group id="field-education" label="ระดับการศึกษา" label-for="education" :state="stateEducation">
          <b-form-select id="education" :options="educationOptions" v-model="education"
            :state="stateEducation"></b-form-select>
        </b-form-group>
        <b-form-group id="field-position" label="ตำแหน่ง" label-for="position" :state="statePosition">
          <b-form-input id="position" v-model="position" :state="statePosition"></b-form-input>
        </b-form-group>
        <b-form-group id="field-institution" label="หน่วยงาน" label-for="institution" :state="stateInstitution">
          <b-form-input id="institution" v-model="institution" :state="stateInstitution"></b-form-input>
        </b-form-group>

        <b-form-group id="field-department" label="สังกัด" label-for="department" :state="stateDepartment">
          <b-form-input id="department" v-model="department" :state="stateDepartment"></b-form-input>
        </b-form-group>
        <b-form-group id="field-email" label="อีเมล" label-for="email" :state="stateEmail">
          <b-form-input id="email" placeholder="example@email.com" v-model="email" :state="stateEmail"
            trim></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col xl="4" offset-xl="4" lg="6" offset-lg="3" md="8" offset-md="2" sm="12" cols="8" offset="2"
        class="text-center mb-3">
        <b-button @click="submit()" id="btnSubmit" class="btn btnmain  mx-1"
          style="cursor: pointer;">ลงทะเบียน</b-button>
      </b-col>
    </b-row>
    <!-- <ImageCrop @image="image = $event" @toggleShow="show = $event" :isShow="show" /> -->
  </div>
</template>

<script>
import TopNav from "@/components/topNav";
// import ImageCrop from "@/components/ImageCrop";
import Loading from "@/components/Loading";
import Swal from "sweetalert2";
// import Google from "@/components/SocialLogin/Google";
// import Facebook from "@/components/SocialLogin/Facebook";
export default {
  components: {
    TopNav,
    Loading,
  },
  computed: {
    computedDateFormatted() {
      if (!this.birthDate) return null;
      const [year, month, day] = this.birthDate.split("-");
      return `${day}/${month}/${parseInt(year) + 543}`;
    },
    stateTitle() {
      return this.title != "";
    },
    stateGender() {
      return this.gender != "";
    },
    stateEducation() {
      return this.education != "";
    },
    stateDepartment() {
      return this.department != "";
    },
    stateFieldStudy() {
      return this.fieldStudy != "";
    },
    stateMajor() {
      return this.major != "";
    },
    stateDegree() {
      return this.degree != "";
    },
    statePosition() {
      return this.position != "";
    },
    stateInstitution() {
      return this.institution != "";
    },
    stateProfession() {
      return this.profession != "";
    },
    stateNotNull() {
      return "";
    },
    stateFirstname() {
      return this.firstname.length > 0;
    },
    stateLastName() {
      return this.lastname.length > 0;
    },
    stateCitizenId() {
      return this.citizen_id != "";
    },
    statePhone() {
      return this.phone != "";
    },
    stateOfficePhone() {
      return this.officePhone != "";
    },
    stateEmail() {
      if (this.email && this.email != "") {
        if (this.email == "") {
          return false;
        }

        const regEmail = this.regEmail.test(this.email);

        if (regEmail) {
          if (
            this.email.includes("@hotmail") ||
            this.email.includes("@outlook")
          ) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    statePassword() {
      if (this.password && this.password != "") {
        if (this.password.length >= 8) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    stateConfirmPassword() {
      if (this.password && this.password != "") {
        if (this.confirmpassword === this.password) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    invalidFeedback() {
      if (this.firstname.length >= 0) {
        return "โปรดกรอกข้อมูล";
      }
      return "โปรดกรอกข้อมูล";
    },
    invalidFeedbackPassword() {
      if (this.confirmpassword != this.password) {
        return false;
      }
      return true;
    },
    invalidFeedbackEmail() {
      let email = this.email;
      if (email) {
        let check_email = this.regEmail.test(email);
        if (!check_email) {
          return "โปรดกรอกข้อมูลให้ถูกต้อง";
        }
        if (email.includes("@hotmail") || email.includes("@outlook")) {
          return "โปรดกรอกข้อมูลให้ถูกต้อง";
        }
      }
      return "โปรดกรอกข้อมูล";
    },
    registerData() {
      return this.$store.state.Auth.registerData;
    }
  },
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return {
      show: false,
      menu: false,
      modal: false,
      menu2: false,
      educationOptions: [
        "ต่ำกว่าปริญญาตรี",
        "ปริญญาตรี",
        "ปริญญาโท",
        "ปริญญาเอก",
        "สูงกว่าปริญญาเอก",
      ],
      // min: minDate,
      max: today,
      image: "",
      regEmail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      firstname: "",
      lastname: "",
      citizen_id: "",
      password: "",
      confirmpassword: "",
      email: "",
      phone: "",
      officePhone: "",
      gender: "",
      address: "-",
      birthDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      title: "",
      position: "",
      otherPosition: "",
      education: "",
      degree: "",
      degreeOther: "",
      fieldStudy: "",
      department: "",
      departmentOther: "",
      major: "",
      minor: "",
      lineId: "",
      technicalPosition: "",
      isLoading: false,
      institution: "",
      otherInstitution: "",
      profession: "",
      otherProfession: "",
    };
  },
  methods: {
    cropPopup() {
      this.$bvModal.show("bv-modal");
    },
    showPassword: function () {
      var passwordInput = document.getElementById("password");
      if (passwordInput.type == "password") {
        passwordInput.type = "text";
      } else {
        passwordInput.type = "password";
      }
    },
    async submit() {
      var institution = this.institution;
      var profession = this.profession;
      if (institution == "อื่นๆ") {
        institution = this.otherInstitution;
      }

      if (profession == "อื่นๆ") {
        profession = this.otherProfession;
      }
      let data = {
        first_name: this.firstname,
        last_name: this.lastname,
        email: this.email,
        password: this.password,
        citizen_id: this.citizen_id,
        phone: this.phone,
        office_phone: this.officePhone,
        title: this.title,
        position: this.position,
        other_position: this.otherPosition,
        education: this.education,
        degree: this.degree,
        degree_other: this.degreeOther,
        field_study: this.fieldStudy,
        department: this.department,
        department_other: this.departmentOther,
        technical_position: this.technicalPosition,
        major: this.major,
        minor: this.minor,
        line_id: this.lineId,
        institution: institution,
        profession,
      };
      let validateResult = this.validateForm(data);
      if (validateResult) {
        await this.goRegister(data);
      }
    },
    validateForm(data) {
      let microsoftExceptionMail =
        data.email.includes("@hotmail") || data.email.includes("@outlook");
      let check_email =
        this.regEmail.test(data.email) && !microsoftExceptionMail;
      if (!check_email) {
        Swal.fire("ผิดพลาด!", "โปรดกรอกอีเมลให้ถูกต้อง", "error");
        return false;
      } else if (this.confirmpassword != data.password) {
        Swal.fire("ผิดพลาด!", "โปรดกรอกรหัสให้ตรงกัน", "error");
        return false;
      }
      return true;
    },
    async goRegister(data) {
      const path = `/login`;
      let formData = new FormData();
      this.isLoading = true;
      formData.append("data", JSON.stringify(data));
      //   formData.append("image", this.image);
      await this.$store.dispatch("Auth/register", formData).then((response) => {
        if (response.code == 200 && !response.result.message) {
          this.isLoading = false;
          Swal.fire({
            title: "สำเร็จ!",
            text: "เข้าสู่ระบบด้วย ThaiD ",
            confirmButtonText: `ตกลง`,
            icon: "success",
          }).then((result) => {
            if (result.isConfirmed) {
              this.$router.push(path);
            }
          });
        } else {
          Swal.fire("ผิดพลาด!", response.result.message, "error");
        }
      });
      this.isLoading = false;
    },
  },
  // async mounted() {
  //   // ดึงจาก store และกัน null/undefined
  //   const reg = this.registerData || {};

  //   // ถ้าไม่มี token ให้เด้งออกทันที
  //   if (!reg.register_token) {
  //     Swal.fire("ผิดพลาด!", "เข้าสู่หน้าลงทะเบียนไม่ถูกต้อง ต้องทำการยืนยันตัวตนผ่าน ThaiID", "error");
  //     this.$router.push({ path: '/' });
  //     return;
  //   }

  //   // เตรียม payload (อย่าใช้ชื่อซ้ำกับ reg/data)
  //   const payload = { register_token: reg.register_token };

  //   try {
  //     this.isLoading = true;

  //     // เรียกตรวจสอบ token
  //     await this.$store.dispatch('Auth/CheckRegisterToken', payload);

  //     // ตรวจผ่าน → เติมค่าฟอร์มจาก reg
  //     this.institution = reg.sub_div || '';
  //     this.department = reg.div || '';
  //     this.firstname = reg.fname || '';
  //     this.lastname = reg.lname || '';
  //     this.email = reg.email || '';
  //     this.title = reg.title || '';
  //     this.position = reg.position || '';
  //     this.citizen_id = reg.personalid || '';

  //     // ไป /register เฉพาะเมื่อยังไม่อยู่หน้านั้น
  //     if (this.$route.path !== '/register') {
  //       this.$router.push({ path: '/register' });
  //     }
  //   } catch (e) {
  //     Swal.fire("ผิดพลาด!", "เข้าสู่หน้าลงทะเบียนไม่ถูกต้อง ต้องทำการยืนยันตัวตนผ่าน ThaiID", "error");
  //     this.$router.push({ path: '/' });
  //   } finally {
  //     this.isLoading = false;
  //   }
  // }
};
</script>

<style lang="scss">
#register {
  height: 100%;
  min-height: 100vh;
}
</style>
